import { list as productsList, StoreType, StorePage } from './products';
import { LanguageCode } from '../languages';
import { addQueryParam } from '../url';

export type StorePageWithUrl = StorePage & { url: string; key: string };

export const getStorePages = (
  language = LanguageCode.EN,
  type = StoreType.US,
) => {
  const localizedList = productsList.reduce(
    (arr: StorePageWithUrl[], product) => {
      const page = product.storePages.find(
        (p) => p.type === type && p.language === language,
      );
      if (page)
        return [
          ...arr,
          {
            ...page,
            key: product.key,
            url: addQueryParam(product.url, 'key', product.key),
          },
        ];

      return arr;
    },
    [],
  );

  return localizedList;
};
